import { inject as service } from '@ember/service';
import { resolve } from 'rsvp';
import Base from 'ember-simple-auth/authenticators/base';

import ApiService from 'cio/services/api';
import { LoginSuccessResponse } from 'cio/authenticators/login-email-password';
import { LoginMeta } from 'cio/pods/login/controller';
import { setAccessCookie, getAccessCookie } from 'cio/utils/auth-cookies';

export default class LoginSSOAuthenticator extends Base {
  @service api!: ApiService;

  restore(_data: unknown) {
    return resolve({
      accessToken: getAccessCookie() as string,
    });
  }

  authenticate({
    email,
    authorizationCode,
    redirectUri,
    meta,
  }: {
    email: string;
    authorizationCode: string;
    redirectUri: string;
    meta: LoginMeta;
  }) {
    return this.api
      .post('login_sso', {
        data: { email, code: authorizationCode, redirect_uri: redirectUri, ga_client_id: meta.ga_client_id },
        ignoreErrors: true,
        pathScope: 'global',
      })
      .then((res: LoginSuccessResponse) => {
        setAccessCookie(res.access_token);

        return { accessToken: res.access_token };
      });
  }
}
